import {SimplePageLayout} from '@flexinet/ui-components';

import {IndexPageHeader} from '../components/IndexPageHeader';
import {RecordsTable} from "../tables/RecordsTable.tsx";

export const ListPage = () => {

    return (
        <SimplePageLayout
            pageHeader={<IndexPageHeader/>}
        >
            <RecordsTable/>
        </SimplePageLayout>
    );
};
